import React, { useEffect } from "react";
import { Card, CardContent, Divider, Typography } from "@mui/material";
// Material-UI icons

import NoResultsFound from "components/NoResults/NoResultsFound";
import { useDispatch, useSelector } from "react-redux";
import { fetchBillingHistory } from "actions/paymentActions";
import { getBillingHistory } from "selectors/paymentSelectors";
import HiddenOn from "components/Wrappers/HiddenOn";
import { Info, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import moment from "moment";
import RenderDataFields from "components/DataFields/RenderDataFields";
// Mock user data

export const BillingInformation = () => {
  const dispatch = useDispatch();
  const billingHistory = useSelector(getBillingHistory);

  // State to track which items are expanded
  const [expandedItems, setExpandedItems] = React.useState({});

  useEffect(() => {
    dispatch(fetchBillingHistory());
  }, [dispatch]);

  // Toggle expanded state for a billing item
  const toggleExpand = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const dataFields = [
    {
      key: "amountpaid",
      label: "Amount",
      dataPath: "amountpaid",
      formatter: (value) => `$ ${value}`,
    },
    {
      key: "paymentProcessDate",
      label: "Payment Date",
      dataPath: "paymentProcessDate",
      formatter: (value) => {
        return moment(value).format("ll");
      },
    },
    {
      key: "startDate",
      label: "Subscription Start",
      dataPath: "startDate",
      formatter: (value) => {
        return moment(value).format("ll");
      },
    },
    {
      key: "endDate",
      label: "Subscription End",
      dataPath: "endDate",
      formatter: (value) => {
        return moment(value).format("ll");
      },
    },
    {
      key: "cardToken",
      label: "Payment Card",
      dataPath: "cardToken",
      formatter: (value) => {
        let maskedValue = "";
        Array.from(value.slice(0, -3)).forEach((x) => (maskedValue += "X"));
        return `${maskedValue}-${value.slice(-3)}`;
      },
    },
  ];

  return (
    <HiddenOn
      isHidden={!billingHistory && billingHistory.length === 0}
      fallback={
        <NoResultsFound
          headerType="h4"
          message={"No Data Available Currently"}
        />
      }
    >
      <div className="container mt-4 mb-5 pe-5">
        {billingHistory.map((item, index) => {
          return (
            <Card className="col-12">
              <CardContent className="d-flex justify-content-between">
                <div className="col-10 d-flex">
                  <div className="mt-1">
                    <Info style={{ fontSize: "20px" }} />
                  </div>
                  <Typography className="h4">
                    {"Invoice For:"}
                    &nbsp; &nbsp;
                    {moment(item.startDate).format("ll")} -
                    {moment(item.endDate).format("ll")}
                  </Typography>
                </div>
                <div
                  onClick={() => {
                    toggleExpand(index);
                  }}
                  className="pointer"
                >
                  {expandedItems[index] ? (
                    <KeyboardArrowUp style={{ fontSize: "25px" }} />
                  ) : (
                    <KeyboardArrowDown style={{ fontSize: "25px" }} />
                  )}
                </div>
              </CardContent>
              {expandedItems[index] && (
                <Divider className="mb-2 divider" style={{ height: "2px" }} />
              )}
              {expandedItems[index] && (
                <div>
                  <RenderDataFields data={item} fields={dataFields} />
                </div>
              )}
            </Card>
          );
        })}
      </div>
    </HiddenOn>
  );
};

export default BillingInformation;
